import axios from "axios";
import { API_URL } from "./config";
import { getAuthItem, clearAuthData } from "../utils/indexDB";
// Base URL for your API
//localhost for now later fetch it from .env
// const API_URL = "http://localhost:8000/api";

/**
 * Generic API call function
 * @param {string} endpoint - The API endpoint (e.g., '/data')
 * @param {string} method - The HTTP method ('GET', 'POST', 'PUT', 'DELETE', etc.)
 * @param {object} [data] - The data to be sent with the request (for POST/PUT)
 * @param {object} [params] - URL parameters for GET requests
 * @returns {Promise} - Resolves with the response data or rejects with an error
 */

let cachedAccessToken = null;

export const clearCachedAccessToken = () => {
  cachedAccessToken = null;
};

export const setCachedAccessToken = (token) => {
  cachedAccessToken = token || null;
};

const getCachedAccessToken = async () => {
  if (cachedAccessToken) {
    return cachedAccessToken;
  }

  try {
    const token = await getAuthItem("accessToken");
    cachedAccessToken = token || null;
  } catch (err) {
    console.error("Error reading accessToken from IndexedDB:", err);
  }
  return cachedAccessToken;
};

// Logged-in courier's session is no longer valid (credentials changed by
// admin, account deleted, etc.): wipe auth and send them to login.
export const forceLogout = async () => {
  cachedAccessToken = null;
  await clearAuthData();
  localStorage.clear();
  if (
    window.location.pathname !== "/" ||
    window.location.hash !== "#/login"
  ) {
    window.location.replace("/#/login");
  }
};

const apiCall = async ({
  endpoint,
  method = "GET",
  data = null,
  params = {},
  headers = {},
}) => {
  const accessToken = await getCachedAccessToken();
  const defaultHeaders = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json", // Default content type
  };

  const config = {
    method,
    headers: { ...defaultHeaders, ...headers },
    url: `${API_URL}${endpoint}`,
    data,
    params,
  };

  try {
    const response = await axios(config);
    // e.g. /otp/get-signup-row returns the courier row with isDeleted
    if (accessToken && response.data?.data?.isDeleted === true) {
      await forceLogout();
      throw response;
    }
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        cachedAccessToken = null;
        if (accessToken && endpoint !== "/login") {
          await forceLogout();
        }
      }
      // Check if there is a response from the server
      if (error.response) {
        throw error.response;
      } else {
        throw error.message;
      }
    } else {
      throw error;
    }
  }
};

export default apiCall;
